export const mapControlResponses = (controls, responses) => {
  return controls.map(control => {
    const matchingResponses = responses.filter(response => {
      return (
        control.controlId.toUpperCase() === response.controlId.toUpperCase()
      );
    });
    return {
      ...control,
      responses: matchingResponses
    };
  });
};
